// A tap at the top of a phone's screen takes the list there back to its top,
// as a tap on the status bar does in an iPhone's own lists (the person,
// 2026-10-27). iOS's own tap reaches only the page's scrolling, and a list
// here scrolls its own column (phone.css), so the frame does it.
//
// Promise:
// - The top is the band the Dock at the top stands in (TOP_DOCK_TOP +
//   TOP_DOCK_HEIGHT, below the status bar when the page runs under it), the
//   whole width (also under the clock's pillar of a home screen app).
// - The Dock's buttons, the list's title row's back and a field there keep
//   their taps. A row gone up under the band does not open: the tap is the
//   list's (the row is faded there).
// - A list already at its top takes nothing: the tap goes on as it would.
// - Smooth, unless the device asks for less motion.
import { useEffect } from "react";
import { phoneTopInset, TOP_DOCK_HEIGHT, TOP_DOCK_TOP } from "./top-dock";

export const TAP_TOP_BAND = TOP_DOCK_TOP + TOP_DOCK_HEIGHT;

const KEEPS_TAP =
  "[data-top-dock], [data-top-dock-title] button, button, input, textarea, select, [contenteditable]";

/** The scrolled list column under a point across the screen, if any. */
function listColumnAt(x: number): HTMLElement | null {
  for (const band of document.querySelectorAll("[data-list-search-page]")) {
    const column = band.parentElement;
    if (!column || column.scrollTop <= 0) continue;
    const box = column.getBoundingClientRect();
    if (x >= box.left && x < box.right) return column;
  }
  return null;
}

export function useTapTopToScroll(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const band = TAP_TOP_BAND + phoneTopInset();
    const onClick = (e: MouseEvent) => {
      if (e.clientY >= band) return;
      const target = e.target instanceof Element ? e.target : null;
      if (target?.closest(KEEPS_TAP)) return;
      const column = listColumnAt(e.clientX);
      if (!column) return;
      e.preventDefault();
      e.stopPropagation();
      const still = window.matchMedia?.(
        "(prefers-reduced-motion: reduce)",
      ).matches;
      column.scrollTo({ top: 0, behavior: still ? "auto" : "smooth" });
    };
    window.addEventListener("click", onClick, true);
    return () => window.removeEventListener("click", onClick, true);
  }, [active]);
}
